import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoachSettingsGeneralState {
	isSaving: boolean;
}

@Injectable()
export class CoachSettingsGeneralStore extends Store<CoachSettingsGeneralState> {
	constructor() {
		super({}, { name: `ui-coach-settings-general-${guid()}` });
	}
}
